import {connect} from 'react-redux';
import AuditSearchVirtualEntryList from './AuditSearchVirtualEntryList.jsx'; 
import {
  handleVirtualEntrySearchEnterKeyPress,
  handleVirtualEntrySearch
} from './actions';
import {
  setSearchVirtualEntryValue
  } from './actionTypes';

const mapStateToProps = state => ({ 
  searchValue: state.admin.virtualEntryAudit.searchVirtualEntryAuditValue,
  exceededResultLimit: state.admin.virtualEntryAudit.searchExceededResultLimit,
  list: state.admin.virtualEntryAudit.searchVirtualEntrys
});

const mapDispatchToProps = dispatch => ({ 
    onSearchEnterKeyPress: event => dispatch(handleVirtualEntrySearchEnterKeyPress(event)),
    onSearchClick: () => dispatch(handleVirtualEntrySearch()),
    onSearchValueChange: searchValue => dispatch(setSearchVirtualEntryValue(searchValue))
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditSearchVirtualEntryList);



// WEBPACK FOOTER //
// ./src/features/admin/audit/virtualEntryAudit/AuditSearchVirtualEntryListContainer.jsx